import m from "../../geodata/es2015/chinaHigh";
window.am4geodata_chinaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/chinaHigh.js
// module id = null
// module chunks = 